import { extendTheme, theme, withDefaultColorScheme } from "@chakra-ui/react";
const colorModeValues = (colorMode, darkModeColor, lightModeColor) => {
    return colorMode === "dark" ? darkModeColor : lightModeColor;
};
export const chakraTheme = extendTheme({
    colors: {
        error: '#AC0000',
        cardBg: '#F2F2F2',
        headerBg: '#F3F3F3',
        whiteDe: ({ colorMode }) => colorModeValues(colorMode, '#000000', '#FFFFFF'),
        blackDe: ({ colorMode }) => colorModeValues(colorMode, '#FFFFFF', '#000000'),
        blackLi: ({ colorMode }) => colorModeValues(colorMode, '#FFFFFF', 'rgba(0,0,0,0.33)'),
        blackMd: ({ colorMode }) => colorModeValues(colorMode, '#FFFFFF', 'rgba(0,0,0,0.8)'),
        brand: {
            50: '#80b5b8',
            100: '#66a6a9',
            200: '#4d979b',
            300: '#33888d',
            400: '#1a797e',
            500: '#006A70',
            600: '#005f65',
            700: '#00555a',
            800: '#004a4e',
            900: '#004043',
        },
        black: Object.assign('#13100D', {
            light: 'rgba(0,0,0,0.33)',
            medium: 'rgba(0,0,0,0.8)',
            dark: '#000000',
        }),
        gray: Object.assign('#CCCCCC', {
            light: '#EDEBE4',
            medium: '#EEEEEE',
            dark: '#999999',
            bg: '#F2F2F2'
        }),
        green: '#80BC00',
        red: Object.assign('#FF2727', {
            off: '#FEEDEE',
            light: '#DB687E',
            error: '#AC0000',
        }),
        white: '#FFFFFF',
        background: '#EBFF00',
        backgroundSecondary: '#003957',
        backgroundSecondaryHover: '#275B76',
        primary: '#006A70',
        primaryHover: '#4DBFC0',
        primaryOff: '#F1FAFB',
        secondary: '#FCC600',
        text: '#003957',
        textSecondary: '#275B76',
        hover: '#F5FcFc',
        dropDownHover: 'rgba(181, 201, 255, 1)',
        // New Colors
        PrimaryBlack: '#1E1E1E',
        PrimaryWhite: '#FAFAFA',
        PrimaryYellow: '#EBFF00',
        SecondaryGray: {
            "50": "#F2F2F2",
            "100": "#DBDBDB",
            "200": "#C4C4C4",
            "300": "#ADADAD",
            "400": "#969696",
            "500": "#808080",
            "600": "#666666",
            "700": "#4D4D4D",
            "800": "#333333",
            "900": "#1A1A1A"
        },
        SecondaryPurpleBlue: "#B5C9FF",
        TertiaryGreen: "#B4FB9C",
        TertiaryOrange: "#FFBD70",
        TertiaryPurple: "#E6B1FF",
        TertiaryRed: "#FB9090",
    },
    sizes: {
        md: '544px',
        container: {
            md: '544px',
        }
    },
    ui: {
        borderRadius: '5px',
    },
    shadows: {
        default: '0px 2px 6px rgba(225, 225, 225, 0.25)',
        overlay: '0px 2px 4px 0px rgba(0,0,0,0.1)',
    },
    fonts: {
        primary: 'UntitledSansRegular, Helvetica, Arial, sans-serif, Roboto',
        secondary: 'UntitledSansMedium, Helvetica, Arial, sans-serif, Roboto',
    },
    logo: {
        primary: '',
        secondary: '',
    },
    borders: {
        'list': `1px solid rgb(0 0 0 / 11%)`
    },
    components: {
        Button: {
            variants: {
                primary: (props) => {
                    var _a, _b, _c;
                    return (Object.assign(Object.assign({}, (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.Button) === null || _b === void 0 ? void 0 : _b.variants) === null || _c === void 0 ? void 0 : _c.outline(props)), { color: "white", backgroundColor: "black" }));
                },
                secondary: (props) => {
                    var _a, _b, _c;
                    return (Object.assign(Object.assign({}, (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.Button) === null || _b === void 0 ? void 0 : _b.variants) === null || _c === void 0 ? void 0 : _c.outline(props)), { color: "black", backgroundColor: "transparent", _hover: {
                            color: "white",
                            backgroundColor: "black",
                            borderColor: "brand.500"
                        } }));
                },
                disabled: (props) => {
                    var _a, _b, _c;
                    return (Object.assign(Object.assign({}, (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.Button) === null || _b === void 0 ? void 0 : _b.variants) === null || _c === void 0 ? void 0 : _c.outline(props)), { color: "gray", border: 0, backgroundColor: "white", _hover: {
                            borderColor: "brand.500"
                        } }));
                },
            }
        },
        Radio: {
            baseStyle: {
                control: {
                    borderColor: "gray.light",
                    height: '16px',
                    width: '16px',
                }
            },
        },
        Checkbox: {
            baseStyle: {
                control: {
                    borderColor: "black.medium",
                    borderWidth: '1px',
                    height: '20px',
                    width: '20px',
                    _checked: {
                        _hover: {
                        // background: "transparent" // logic to change hover color
                        }
                    }
                }
            },
        }
    }
}, withDefaultColorScheme({
    colorScheme: 'brand',
    components: ['Checkbox'],
}));
//# sourceMappingURL=chakraTheme.js.map